
import colors from './colors';
import images from './images';

export const ThemeColors = colors;
export const ThemeImages = images;



// WEBPACK FOOTER //
// ./src/app/theme/index.js